import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { cn } from "styles/utils"

const ItemContainer = ({ className, ...props }) => {
  const holdbackExp = useSelector(
    (state) => state.experiment.holdback.variant_id
  )

  return (
    <li
      className={cn(
        "relative",
        holdbackExp === 1 && "tablet:mb-30 mx-auto mb-24 mt-4 px-8 text-center",
        className
      )}
      {...props}
    />
  )
}

ItemContainer.propTypes = {
  className: PropTypes.string,
}

export default ItemContainer
